/** Shared approval-cohort year ceiling for public Solar (ClimatePlans analysis window). */
export const SOLAR_ANALYSIS_CUTOFF_YEAR = 2026;

export function isSolarApprovalCohortYear(year: number): boolean {
  return Number.isFinite(year) && year <= SOLAR_ANALYSIS_CUTOFF_YEAR;
}

export const SOLAR_PUBLIC_TIME_SEMANTICS =
  'current interconnected Project Sites grouped by App Approved Date approval cohort';
